import { render } from "./ArtefactShapedImage.vue?vue&type=template&id=7529a6fb&scoped=true"
import script from "./ArtefactShapedImage.vue?vue&type=script&lang=js"
export * from "./ArtefactShapedImage.vue?vue&type=script&lang=js"

import "./ArtefactShapedImage.vue?vue&type=style&index=0&id=7529a6fb&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7529a6fb"]])

export default __exports__